import Vue from 'vue'
import Router from 'vue-router'

import Footer from '@/components/footer'
import PageNotFound from '@/components/pagenotfound'
import js from '@/components/js'
import color from '@/components/color'
import Navbar_tutorial from '../components/navbar_tutorial'
import Explain_object_test from '../components/explain_object_test'

import Tutorial_main from '@/pages/tutorial_main'
import Menu from '@/pages/menu'
import Function from '@/pages/function'

import Edit_menu from '@/pages/tutorial_menu/edit_menu'
import Tool_menu from '@/pages/tutorial_menu/tool_menu'
import Advanced_menu from '@/pages/tutorial_menu/advanced_menu'
import Look_menu from '@/pages/tutorial_menu/look_menu'
import Settings_menu from '@/pages/tutorial_menu/settings_menu'

import Function_interface from '@/pages/tutorial_functions/function_interface'
import Function_screen_control from '@/pages/tutorial_functions/function_screen_control'
import Function_file from '@/pages/tutorial_functions/function_file'
import Function_shape from '@/pages/tutorial_functions/function_shape'
import Modeling from '@/pages/modeling'
import Contact_form from '@/pages/contact_form'
import Explain_test from '@/pages/explain_test'

import Test from '@/demo_page/test'


Vue.use(Router)
Vue.component('Footer', Footer)
Vue.component('js', js)
Vue.component('color', color)
// Vue.compoenet('Explain_object_test', Explain_object_test)
Vue.component('Navbar_tutorial', Navbar_tutorial)


export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      components: {
        default: Tutorial_main,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/404',
      name: 'pagenotfound',
      component: PageNotFound
    },
    {
      path: '/tutorial_main',
      name: 'Tutorial_main',
      components: {
        default: Tutorial_main,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu',
      name: 'Menu',
      components: {
        default: Menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/function',
      name: 'Function',
      components: {
        default: Function,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu/edit',
      name: 'Edit_menu',
      components:{
        default: Edit_menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu/tool',
      name: 'Tool_menu',
      components:{
        default: Tool_menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu/advanced',
      name: 'Advanced_menu',
      components:{
        default: Advanced_menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu/look',
      name: 'Look_menu',
      components:{
        default: Look_menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/menu/setting',
      name: 'Settings_menu',
      components:{
        default: Settings_menu,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/function/interface',
      name: 'Function_interface',
      components:{
        default: Function_interface,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/function/screen',
      name: 'Function_screen_control',
      components:{
        default: Function_screen_control,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/function/file',
      name: 'Function_file',
      components:{
        default: Function_file,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/function/shape',
      name: 'Function_shape',
      components:{
        default: Function_shape,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/modeling',
      name: 'Modeling',
      components:{
        default: Modeling,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/explain_test',
      name: 'Explain_test',
      components:{
        default: Explain_test,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/contact_form',
      name: 'Contact_form',
      components:{
        default: Contact_form,
        navbar: Navbar_tutorial,
      }
    },
    {
      path: '/test',
      component: Test
    },
    {
      path: '*',
      redirect: '/404'
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js